import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

import StrengthRectangle from '../../atoms/StrengthRectangle'

const Content = styled(View)`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: row;
  align-items: center;
  background-color: transparent;
  justify-content: space-between;
`

const Wrapper = styled(View)`
  margin-left: 5px;
  flex: 1;
`

const FirstRectangleWrapper = styled(View)`
  flex: 1;
`

const levelCalc = (index, level) => (level >= index ? level : 0)

const strengthMeter = props => {
  const { level } = props
  return (
    <Content>
      <FirstRectangleWrapper>
        <StrengthRectangle level={levelCalc(1, level)} />
      </FirstRectangleWrapper>
      <Wrapper>
        <StrengthRectangle level={levelCalc(2, level)} />
      </Wrapper>
      <Wrapper>
        <StrengthRectangle level={levelCalc(3, level)} />
      </Wrapper>
      <Wrapper>
        <StrengthRectangle level={levelCalc(4, level)} />
      </Wrapper>
    </Content>
  )
}

strengthMeter.defaultProps = {
  level: 0,
}

strengthMeter.propTypes = {
  level: PropTypes.number,
}

export default strengthMeter
